exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrapped-text{word-break:break-all;width:30%}", ""]);

// exports
